import { motion } from 'framer-motion';
import type { ReactNode } from 'react';

/**
 * Transição de entrada entre rotas.
 *
 * ⚠ A OPACIDADE NÃO ENTRA NA ANIMAÇÃO DE ENTRADA — de propósito.
 *
 * O navegador congela o `requestAnimationFrame` em aba oculta ou sem foco.
 * Com `initial={{ opacity: 0 }}`, a animação nunca avança e o conteúdo fica
 * preso no estado inicial: página em branco ou desbotada. Foi o que aconteceu
 * com o hero das landing pages de anúncio em agosto, e o mesmo defeito estava
 * aqui, atingindo home, áreas e privacidade — reproduzido em 06/09/2026 com
 * `document.hasFocus() === false`, wrapper parado em `opacity: 0.609`.
 *
 * Cenário real: a pessoa clica no link, troca de aba enquanto carrega, volta
 * e encontra a página apagada.
 *
 * Regra permanente deste projeto: **conteúdo visível por padrão; animação só
 * enriquece o que já aparece.** Aqui sobra apenas um deslocamento vertical
 * curto — se o rAF congelar, o pior caso é o conteúdo 10px abaixo do lugar,
 * o que ninguém percebe, em vez de invisível.
 *
 * A saída (`exit`) pode animar opacidade sem risco: ela só roda com a aba
 * ativa, no clique de navegação.
 */
export const PageTransition = ({ children }: { children: ReactNode }) => (
    <motion.div
        initial={{ y: 10 }}
        animate={{ y: 0 }}
        exit={{ opacity: 0, y: -8 }}
        transition={{ duration: 0.45, ease: [0.21, 0.47, 0.32, 0.98] }}
    >
        {children}
    </motion.div>
);
